import { render, staticRenderFns } from "./CreateTemplateDialog.vue?vue&type=template&id=cb812872&scoped=true"
import script from "@/views/RosterTemplates/CreateTemplateDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/RosterTemplates/CreateTemplateDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/RosterTemplates/create-template-dialog.scss?vue&type=style&index=0&id=cb812872&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb812872",
  null
  
)

export default component.exports